import React from 'react'
import { InputChips, TextField } from '@fs/zion-ui'
import { useChipFormSync } from './useChipFormSync'
import { useChipInputHandlers } from './useChipInputHandlers'

export const BaseChipInput = React.memo(function BaseChipInput({ name, methods, label, placeholder }) {
  const { chipCollection, addChip, removeChip } = useChipFormSync({ name, methods })

  const { inputValue, handleInputChange, handleEnterKey } = useChipInputHandlers({
    onAddChip: addChip,
  })

  return (
    <>
      <TextField
        label={label}
        placeholder={placeholder}
        value={inputValue}
        onChange={handleInputChange}
        onEnterKey={handleEnterKey}
      />
      <InputChips chipCollection={chipCollection} isSelectable onDismiss={removeChip} ariaChipDescription={name} />
    </>
  )
})
